import { useIntl } from "react-intl";
import Box from "@mui/material/CardContent";
import { Typography } from "@mui/material";
import CustomInput from "../CustomInput";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { max } from "moment";

const SizeAndQty = (props) => {
  const { sizeDescription, renderedQty, maxQty, isInEdit, setTotalQuantity, isSelected, defaultQty, key, tempQty } =
    props;
  const intl = useIntl();

  const [qty, setQty] = useState(defaultQty ? renderedQty : null);

  useEffect(() => {
    if (tempQty != null) {
      setQty(tempQty)
    }
  }, []);

  useEffect(() => {
    if (setTotalQuantity && isSelected) {
      handleChangeQty(null, maxQty, true)
    }
  }, [setTotalQuantity]);

  const handleChangeQty = (value, maxQty, setTotQty) => {
    if(setTotQty){
      setQty(maxQty);
      props.valueChangedFunction(maxQty);
      props.resetSetTotalQuantity();
      return;
    }
    
    if (value != "" && (value > maxQty || value <= 0)) {
      toast.error(
        intl.formatMessage({ id: "RAPreparing.Add.ErrorQty" }) + maxQty
      );
      value = maxQty;
    }
    
    setQty(value);
    props.valueChangedFunction(value);
  };

  return (
    <Box
      sx={{
        width: isInEdit ? 50 : 35,
        color: "white",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: `3px solid #85ABD5`,
        borderRadius: 1,
        padding: 0,
        paddingBottom: "0 !important",
      }}
    >
      <Typography
        fontWeight="bold"
        variant="body2"
        className="apeLigthBlueBackground"
        sx={{
          width: "100%",
        }}
      >
        {sizeDescription}
      </Typography>
      {isInEdit == true ? (
        <Typography
          sx={{
            bgcolor: "#b0d5fc",
            color: "black",
            width: "100%",
          }}
        >
          {maxQty}
        </Typography>
      ) : (
        ""
      )}
      {isInEdit ? (
        <CustomInput
          id={key}
          type="number"
          value={qty}
          setValue={(e) => {
            handleChangeQty(e, maxQty, false);
          }}
          max={maxQty}
          classInput="alignCenter"
          inputCol={12}
          textCol={0}
        />
      ) : (
        <Typography
          sx={{
            color: "black",
            width: "100%",
          }}
        >
          {renderedQty}
        </Typography>
      )}
    </Box>
  );
};

export default SizeAndQty;
